module.exports = __webpack_public_path__ + "front/img/33_5.8f35f6ca.png";